import { BusinessProduct } from "../../../../../models/state";

const initialState: BusinessProduct = {
    sku: "",
    name: "",
    brand: "",
    model: "",
    color: "",
};

const reducer: (state?: BusinessProduct) => BusinessProduct = (state = initialState) => state;

export default reducer;
